import ProgressIndicatorSingleIndicator from './ProgressIndicatorSingleIndicator';
import { ProgressIndicatorItemMultiModified } from './useProgressIndicator';

const ProgressIndicatorMultiIndicator: React.FunctionComponent<ProgressIndicatorItemMultiModified> =
  function ({ active, substeps, type, ...rest }) {
    return (
      <div className="flex flex-row flex-[1_1_0]">
        {!active ? (
          <ProgressIndicatorSingleIndicator
            type="single"
            {...rest}
            active={false}
          />
        ) : (
          substeps.map(({ key, ...substep }) => (
            <ProgressIndicatorSingleIndicator key={key} {...substep} />
          ))
        )}
      </div>
    );
  };

export default ProgressIndicatorMultiIndicator;
